// extracted by mini-css-extract-plugin
export default {"root":"styles_root__fpHlc","card":"styles_card__QGthg","form-item":"styles_form-item__oumyo","formItem":"styles_form-item__oumyo"};